export class RefTva {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code' },
        libelle: { key: 'libelle' },
        montant: { key: 'montant' }
    };

    id: number = undefined;
    code: string = undefined;
    libelle: string = undefined;
    montant: number = undefined;
}
